import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Stack } from "react-bootstrap"
import { redirectLogin } from "../utils/session"
import { useAuth } from "../api/auth/store"
import { useDataGeneration } from "../api/generate/store"
import useUXStore from "../api/ux/store"
import ProfileImage from "./ProfileImage"
import { AUTH_SERVER } from "../constants"
import { useNavigate } from "react-router"
import useSettingsDialog from "./SettingsDialog"
import './../css/Topbar.css'
import cocreeLogo from "../assets/COCREE.png"

const AccountBar = () => {
    const [isInit, setInit] = useState(false)
    const { user, loading, logout, isLogin, init } = useAuth( state => state)
    const { showSettingsDialog } = useSettingsDialog()
    useEffect(() =>{
        if (!isInit) {
            init().finally( () => {
                setInit(true)
            })
        }
    }, [])
    if (loading) {
        return <></>
    }
    if (!isLogin) {
        return <Button size="sm" onClick={() => {
            redirectLogin()
        }}>Login</Button>
    }
    const onLogout = () => {
        logout()
        window.location.reload()
    }
    const onAccount = () => {
        window.location.href = AUTH_SERVER!
    }
    const onSettings = () => {
        showSettingsDialog()
    }
    return <div className="account-section">
        <Dropdown>
            <Dropdown.Toggle className="dropdownt" size="sm" variant="" id="dropdown-basic">
                {user && <ProfileImage name={user.dis} size={30} bgcolor="rgb(155, 186, 255)"/>}
            </Dropdown.Toggle>
            {user && <Dropdown.Menu>
                <Dropdown.Item onClick={onSettings}>Settings</Dropdown.Item>
                <Dropdown.Item onClick={onAccount}>Account</Dropdown.Item>
                <Dropdown.Item onClick={onLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>}
        </Dropdown>
    </div>
}

const Topbar: React.FC = () => {
    const navigate = useNavigate()
    const { discardUnsaved, unfocus } = useDataGeneration(state => ({
        discardUnsaved: state.discardUnsaved,
        unfocus: state.unfocus,
    }))
    const { sessionExpired, setSessionExpired, isLogin } = useAuth(state => ({
        sessionExpired: state.sessionExpired,
        setSessionExpired: state.setSessionExpired,
        isLogin: state.isLogin,
    }))
    const { refreshDialog } = useUXStore(state => state)

    useEffect(() => {
        const handler = () => setSessionExpired(true)
        window.addEventListener("session-expired", handler)

        if (isLogin && sessionExpired) {
            refreshDialog({
                id: "session-timeout",
                title: "Session Expired",
                content: "Your session has expired. Please re-authenticate to continue.",
                visible: true,
                confirmContent: "Re-authenticate",
                confirmActive: true,
                onConfirm: () => {
                    setSessionExpired(false)
                    window.location.href = '/'
                }
            }, true)
        }

        return () => window.removeEventListener("session-expired", handler)
    }, [sessionExpired, setSessionExpired, isLogin, refreshDialog])

    const handleBrandClick = () => {
        discardUnsaved()
        unfocus()
        navigate('/')
    }

    return (
        <nav className="topbar">
            <div className='container'>
                <Stack direction="horizontal" gap={3} className="topbar-content">
                    <button
                        type="button"
                        className="brand-name brand-button brand-logo"
                        onClick={handleBrandClick}
                    >
                        <div className="brand-logo-wrapper">
                            <img src={cocreeLogo} alt="COCREE logo" className="brand-logo-image" />
                            <div className="brand-text">
                                <div className="brand-title">
                                    RMS-<strong>COCREE</strong>
                                </div>
                                <div className="brand-subtitle">
                                    Report Generation
                                </div>
                            </div>
                        </div>
                    </button>

                    <AccountBar />
                </Stack>
            </div>
        </nav>
    )
}

export default Topbar
